import { ArrowLeft } from 'lucide-react';
import { Link } from '../../app/router';
import { Logo } from '../../shared/components';

const LAST_UPDATED = 'August 1, 2026';

export function PrivacyPage() {
  return <div className="legal-page">
    <header className="legal-page__topbar">
      <Link to="/" aria-label="กลับหน้าแรก"><ArrowLeft /></Link>
      <Link to="/"><Logo /></Link>
    </header>
    <main className="legal-page__content">
      <h1>Privacy Policy</h1>
      <p className="legal-page__updated">Last updated: {LAST_UPDATED}</p>

      <p>beaw.club (&quot;we&quot;, &quot;us&quot;) helps you discover coffee and cafes in expert communities. This policy explains what we collect, why, and your choices.</p>

      <h2>Information we collect</h2>
      <ul>
        <li><strong>Account data</strong> — name, email or phone number, and password, when you sign up or log in.</li>
        <li><strong>Content you create</strong> — reviews, ratings, posts, photos, and profile details.</li>
        <li><strong>Usage &amp; device data</strong> — searches, pages viewed, approximate location, and basic device/browser info.</li>
        <li><strong>Rewards data</strong> — wallet balance, campaigns, and reward activity you take part in.</li>
      </ul>

      <h2>How we use it</h2>
      <ul>
        <li>Provide and personalize search and recommendations.</li>
        <li>Operate accounts, reviews, communities, and reward programs.</li>
        <li>Keep the service secure and prevent abuse.</li>
        <li>Communicate about your account (e.g. OTP, notifications you opt into).</li>
      </ul>

      <h2>Identity verification documents</h2>
      <p>Beaw Club does not collect face data. We do not perform facial recognition, face matching, face tracking, or liveness detection, we do not use ARKit, the TrueDepth camera, Face ID, or any biometric SDK, and we do not create or store facial templates or other biometric identifiers.</p>
      <p>If you apply to become a creator — a reviewer eligible for paid campaigns — we ask for one photograph of a government-issued ID document so that a Beaw Club administrator can verify your identity before we make any payout, as required by Thai tax and anti-fraud rules. This is optional: you do not need it to browse, search, post reviews, or use any other part of the app.</p>
      <p>The image is uploaded to a private Cloudflare R2 bucket, is never published or served from a public URL, and can only be opened by an authorised administrator through a short-lived signed link. It is reviewed by a person, never by an automated or biometric system. Any face printed on the document is incidental to the document image and is never extracted, analysed, or compared. We never share it with third parties and never use it for advertising, analytics, profiling, or model training.</p>
      <p>We delete the image as soon as the verification decision is made — approved or rejected — keeping only the outcome, and we delete it immediately if you delete your account from Settings → Delete Account. No copy is retained after either event.</p>

      <h2>Sharing</h2>
      <p>We do not sell your personal data. We share it only with service providers that run the platform on our behalf (e.g. hosting, media storage, SMS/email delivery), and when required by law. Content you post publicly (reviews, community posts) is visible to others.</p>

      <h2>Your choices</h2>
      <ul>
        <li>View, edit, or delete your profile and content from your account.</li>
        <li>Turn push notifications on or off in your device settings.</li>
        <li>Request access to or deletion of your account data by contacting us.</li>
      </ul>

      <h2>Data retention</h2>
      <p>We keep your data while your account is active and as needed to provide the service or meet legal obligations. You can ask us to delete your account at any time. Identity verification documents are an exception and are deleted as soon as the verification decision is made, or immediately on account deletion, whichever comes first.</p>

      <h2>Contact</h2>
      <p>Questions about privacy? Email <a href="mailto:support@beaw.club">support@beaw.club</a>.</p>
    </main>
  </div>;
}
